import { render, staticRenderFns } from "./InputDublicateBlock.vue?vue&type=template&id=5845ec7b&"
import script from "./InputDublicateBlock.vue?vue&type=script&lang=js&"
export * from "./InputDublicateBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports